import React from 'react';
import { trackFormError } from 'Utils/Analytics';
import { Markdown } from 'Components/Markdown';

export const SubmitError = ({ error, alignCenter, formName, trackError = true }) => {
  //once convert all forms to use formHook, move just the tracking logic here into formHook
  const message = typeof error === 'string' ? error : error && error.message;
  if (typeof message !== 'string' || message.length === 0) return null;
  if (trackError) {
    trackFormError(formName, error);
  }

  return (
    <div className={`formSubmitContainer ${alignCenter ? 'alignCenter' : ''}`}>
      <span className="formSubmitError">
        <Markdown>{message}</Markdown>
      </span>
    </div>
  );
};
